/* Gameness collection filter breakpoint adapter.
   The base theme keeps the native component behavior; this only moves its drawer
   breakpoint from 768px to the catalog layout's 1024px breakpoint. */
(function() {
  function collapseInactiveGroups(component) {
    var triggers = component.querySelectorAll(
      '[data-collapsible-trigger]:not([data-show-more-trigger])'
    );

    triggers.forEach(function(trigger) {
      var isActive = trigger.getAttribute('data-filter-active') === 'true';
      if (trigger.classList.contains('is-expanded') && !isActive) {
        trigger.dispatchEvent(new Event('click'));
      }
    });
  }

  function enhanceCollectionFilters(component) {
    if (component.hasAttribute('data-gameness-breakpoint-ready')) return;

    var collection = component.closest('.collection--compact-catalog');
    var breakpoint = Number.parseInt(
      component.getAttribute('data-gameness-filter-breakpoint') || '1024',
      10
    );

    if (!Number.isFinite(breakpoint)) return;

    component.setAttribute('data-gameness-breakpoint-ready', 'true');
    if (collection) {
      collection.classList.toggle(
        'collection--filters-empty',
        !component.querySelector('[data-collection-filter]')
      );
    }

    component.filtersResizeEvents = function() {
      var useDrawer = window.innerWidth < breakpoint;

      this.desktopFilterDrawer = useDrawer;
      this.classList.toggle('collection--filter-drawer', useDrawer);

      if (useDrawer) {
        collapseInactiveGroups(this);
        this.hideFiltersDrawer();
        return;
      }

      this.showFiltersOnDesktop();
      this.hideFiltersDrawer();
    };

    component.filtersResizeEvents();
  }

  function initCollectionFilters() {
    document
      .querySelectorAll('collection-filters[data-gameness-filter-breakpoint]')
      .forEach(enhanceCollectionFilters);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionFilters, { once: true });
  } else {
    initCollectionFilters();
  }
})();
